import React, { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";
import { H1, Sub, Skeleton } from "./_shared";

export default function SettingsSection() {
  const [s, setS] = useState(null);
  const load = useCallback(() => api.get("/admin/settings").then((r) => setS(r.data)), []);
  useEffect(() => { load(); }, [load]);
  const save = async () => {
    try { const { data } = await api.patch("/admin/settings", s); setS(data); toast.success("Settings saved"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail) || e.message); }
  };
  if (!s) return <Skeleton />;
  return (
    <div data-testid="cp-settings">
      <H1>Platform settings</H1>
      <Sub>Live configuration — applies immediately.</Sub>
      <div className="mt-6 max-w-xl pp-card-elevated p-6 space-y-4">
        <label className="block">
          <div className="text-xs text-zinc-500 uppercase tracking-wider mb-1">Platform fee (%)</div>
          <input type="number" min={0} max={50} step={0.5} className="pp-input" value={s.platform_fee_pct} onChange={(e) => setS({ ...s, platform_fee_pct: Number(e.target.value) })} data-testid="cp-setting-fee" />
        </label>
        <label className="flex items-center gap-2">
          <input type="checkbox" checked={s.signup_open} onChange={(e) => setS({ ...s, signup_open: e.target.checked })} data-testid="cp-set-signup" /> Public signup open
        </label>
        <label className="flex items-center gap-2">
          <input type="checkbox" checked={s.maintenance_mode} onChange={(e) => setS({ ...s, maintenance_mode: e.target.checked })} data-testid="cp-set-maint" /> Maintenance mode
        </label>
        <button onClick={save} data-testid="cp-setting-save" className="pp-btn-primary px-5 py-3 rounded-xl">Save</button>
      </div>
    </div>
  );
}
